module.exports = __webpack_public_path__ + "static/img/qipaotu.6f561c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service/qipaotu.png
// module id = ihde
// module chunks = 4